import { IApplicationState } from '../../types/redux';

export const selectFeatures = (state: IApplicationState) => {
  return state.projectData.project.features;
};
